/* eslint-disable import/prefer-default-export */
export const isServer = () => typeof window === 'undefined';
